<template>
  <div class="col-6 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">Editar Cotización</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Fecha (*) </label>

                <el-input
                  v-model="formData.date"
                  v-validate="modelValidations.date"
                  name="date"
                  placeholder="Fecha"
                  :disabled="true"
                >
                </el-input>

                <small v-show="date.invalid" class="text-danger">
                  {{ getError('date') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Divisa (*) </label>

                <el-input
                  v-model="formData.divisa"
                  v-validate="modelValidations.divisa"
                  name="divisa"
                  placeholder="Divisa"
                  suffix-icon="fas fa-dollar-sign"
                >
                </el-input>

                <small class="text-muted d-block"> moneda: ARS </small>

                <small v-show="divisa.invalid" class="text-danger">
                  {{ getError('divisa') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Billete (*) </label>

                <el-input
                  v-model="formData.billete"
                  v-validate="modelValidations.billete"
                  name="billete"
                  placeholder="Billete"
                  suffix-icon="fas fa-dollar-sign"
                >
                </el-input>

                <small class="text-muted d-block"> moneda: ARS </small>

                <small v-show="billete.invalid" class="text-danger">
                  {{ getError('billete') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Manual (*) </label>

                <el-input
                  v-model="formData.manual"
                  v-validate="modelValidations.manual"
                  name="manual"
                  placeholder="manual"
                  suffix-icon="fas fa-dollar-sign"
                >
                </el-input>

                <small class="text-muted d-block"> moneda: ARS </small>

                <small v-show="manual.invalid" class="text-danger">
                  {{ getError('manual') }}
                </small>
              </div>
            </div>

            <div class="col-md-12 text-right">
              <base-button cy-id="save-edit-dollar" native-type="submit" type="primary"> Guardar </base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from 'element-ui';
import { mapFields } from 'vee-validate';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
  },

  props: {
    dollarQuotation: {
      type: Object,
      default: () => {
        return {
          date: null,
          divisa: null,
          billete: null,
          manual: null,
        };
      },
    },
  },

  data() {
    return {
      validated: false,

      formData: {
        date: this.dollarQuotation.date,
        divisa: this.dollarQuotation.divisa,
        billete: this.dollarQuotation.billete,
        manual: this.dollarQuotation.manual,
      },

      modelValidations: {
        date: {
          required: true,
        },

        divisa: {
          required: true,
          decimal: true,
        },

        billete: {
          required: true,
          decimal: true,
        },

        manual: {
          required: true,
          decimal: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['date', 'divisa', 'billete', 'manual']),
  },

  methods: {
    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
